import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import Dialog from 'react-bootstrap-dialog';

import { Table, Button } from 'react-bootstrap';
import TooltipButton from './TooltipButton';

import Moment from 'moment';

class OrganisationNotificationEmailRulesTable extends Component {
    didConfirmDelete(rule) {
        this.props.onDelete(rule);
    }

    handleDeleteClicked(rule) {
        const { t } = this.props;

        this.dialog.show({
            title: t('Dialog.warning'),
            body: t('Dialog.sure_deletion'),
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => console.log('Cancel!'),
                    'btn-default'
                ),
                Dialog.Action(
                    t('Dialog.delete'),
                    () => this.didConfirmDelete(rule),
                    'btn-danger'
                )
            ],
            bsSize: 'large',
            onHide: dialog => {
                dialog.hide();
            }
        });
    }

    getDescription(rule) {
        const { t } = this.props;

        if (rule.type_id == 1) {
            return (
                <p>
                    {`${t('OrganisationNotificationEmailRulesTable.the_date_is_between')} `}
                    <span className="label label-success">
                        {Moment(rule.start_date).format(
                            'MMMM Do YYYY, h:mm:ss a'
                        )}
                    </span>{' '}
                    {`${t('OrganisationNotificationEmailRulesTable.and')} `}
                    <span className="label label-success">
                        {Moment(rule.end_date).format(
                            'MMMM Do YYYY, h:mm:ss a'
                        )}
                    </span>{' '}
                </p>
            );
        } else if (rule.type_id == 2) {
            return (
                <p>
                    {rule.exclude ? `${t('OrganisationNotificationEmailRulesTable.the_player_must_not_have_the')} ` : `${t('OrganisationNotificationEmailRulesTable.the_player_must_have_the')} `}

                    <span className="label label-success">
                        {rule.attribute_name}
                    </span>{' '}
                    {`${t('OrganisationNotificationEmailRulesTable.attribute')}`}
                </p>
            );
        } else if (rule.type_id == 3) {
            return (
                <p>
                    {`${t('OrganisationNotificationEmailRulesTable.every')} `}
                    <span className="label label-success">
                        {this.getValidDays(rule)}
                    </span>{' '}
                    {`${t('OrganisationNotificationEmailRulesTable.the_time_is_between')} `}
                    <span className="label label-success">
                        {Moment(rule.start_time).format('h:mm a')}
                    </span>{' '}
                    {`${t('OrganisationNotificationEmailRulesTable.and')} `}
                    <span className="label label-success">
                        {Moment(rule.end_time).format('h:mm a')}
                    </span>{' '}
                </p>
            );
        }
    }

    getValidDays(rule) {
        var abbreviations = '';
        if (rule.monday == true) {
            abbreviations += 'M';
        } else {
            abbreviations += '-';
        }
        if (rule.tuesday == true) {
            abbreviations += 'T';
        } else {
            abbreviations += '-';
        }
        if (rule.wednesday == true) {
            abbreviations += 'W';
        } else {
            abbreviations += '-';
        }
        if (rule.thursday == true) {
            abbreviations += 'T';
        } else {
            abbreviations += '-';
        }
        if (rule.friday == true) {
            abbreviations += 'F';
        } else {
            abbreviations += '-';
        }
        if (rule.saturday == true) {
            abbreviations += 'S';
        } else {
            abbreviations += '-';
        }
        if (rule.sunday == true) {
            abbreviations += 'S';
        } else {
            abbreviations += '-';
        }

        return abbreviations;
    }

    render() {
        const { t } = this.props;

        let ruleRows = this.props.rules.map((rule, index) => {
            console.log(`Rule: ${JSON.stringify(rule)}`);
            return (
                <tr key={index}>
                    <td>{rule.name}</td>
                    <td width={150}>
                        {' '}
                        <span className="label label-default">
                            {rule.type_description}
                        </span>
                    </td>
                    <td>{this.getDescription(rule)}</td>

                    <td align="center">
                        {this.props.userIsAuthorized(this.props.user, [
                            'staff_super_admin',
                            'staff_admin',
                            'organisation_admin',
                            'organisation_user'
                        ]) ? (
                            <Fragment>
                                <TooltipButton
                                    id=""
                                    className="btn-default"
                                    tooltip={t('OrganisationNotificationEmailRulesTable.editrule')}
                                    onClick={() =>
                                        this.props.handleEditClicked(rule)
                                    }
                                >
                                    <em className="fas fa-pencil-alt" />
                                </TooltipButton>
                                <TooltipButton
                                    id="deleteButton"
                                    className="btn-danger pull-right"
                                    tooltip={t('OrganisationNotificationEmailRulesTable.deleterule')}
                                    onClick={() =>
                                        this.handleDeleteClicked(rule)
                                    }
                                >
                                    <em className="fa fa-trash" />
                                </TooltipButton>
                            </Fragment>
                        ) : null}
                    </td>
                </tr>
            );
        });

        return (
            <div id="OrganisationNotificationEmailRulesTable">
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />
                <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            <th width={250}>{t('OrganisationNotificationEmailRulesTable.name')}</th>
                            <th width={150}>{t('OrganisationNotificationEmailRulesTable.type')}</th>
                            <th>{t('OrganisationNotificationEmailRulesTable.description')}</th>
                            <th>
                                <em className="fa fa-cog" />
                            </th>
                        </tr>
                    </thead>
                    <tbody>{ruleRows}</tbody>
                </Table>
            </div>
        );
    }
}

export default translate('translations')(OrganisationNotificationEmailRulesTable);